<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_employees") }}
      </h1>
    </div>

    <!-- Add Employee Form Section -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="
        $store.getters['checkUserAccess']({
          id: '28',
          action: 'add',
        })
      "
    >
      <div class="">
        <form @submit="addEmployee">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
          <BaseInput
            v-model="name"
            :label="$t('employee_name')"
            :placeholder="$t('employee_name')"
            :rules="rules"
            :isError="checkRulesIsError(name, 'add', rules).isError"
            :errorMsg="checkRulesIsError(name, 'add', rules).errorMsg"
          />
          <BaseInput
            v-model="email"
            :label="$t('email')"
            :placeholder="$t('email')"
            :rules="rulesEmail"
            :isError="checkRulesIsError(email, 'add', rulesEmail).isError"
            :errorMsg="checkRulesIsError(email, 'add', rulesEmail).errorMsg"
          /><BaseInput
            v-model="u_phone"
            :label="$t('phone_number')"
            :placeholder="$t('phone_number')"
            :rules="rules"
            :isError="checkRulesIsError(u_phone, 'add', rules).isError"
            :errorMsg="checkRulesIsError(u_phone, 'add', rules).errorMsg"
          /><BaseInput
            v-model="password"
            :label="$t('password')"
            :placeholder="$t('password')"
            :rules="rules"
            :isError="checkRulesIsError(password, 'add', rules).isError"
            :errorMsg="checkRulesIsError(password, 'add', rules).errorMsg"
          />
          <DropdownInput
            v-model="ro_id"
            :label="$t('choose_role')"
            :placeholder="$t('choose_role')"
            :rules="rules_dropdown"
            :items="convertToListIdValueRoles"
            :isError="
              checkRulesIsError(ro_id, 'add', this.rules_dropdown).isError
            "
            :errorMsg="
              checkRulesIsError(ro_id, 'add', this.rules_dropdown).errorMsg
            "
          />   <div class="mb-6">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
              {{ $t('box_access') }}
            </label>
            <CustomMultiSelect
              v-model="selectedBoxes"
              :options="boxOptions"
              :placeholder="$t('select_boxes')"
              :headerText="$t('select_boxes_for_employee')"
              :searchPlaceholder="$t('search_boxes')"
              :noResultsText="$t('no_boxes_found')"
              :searchable="true"
              :showSelectAll="true"
              :showClearAll="true"
              prefixIcon="fa fa-box"
              :helperText="$t('leave_empty_for_all_boxes')"
            />
          </div>
          </div>

          <!-- Box Access Selection -->
       

          <ButtonInput
            type="button"
            @click="addEmployee"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <div
    class="w-full"
    id="printDev"
    v-if="
      $store.getters['checkUserAccess']({
        id: '28',
        action: 'view',
      })
    "
  >
    <div
      :class="
        ' mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl ' +
        ($store.getters['isRtl']
          ? ' md:mr-60 '
          : ' md:ml-60  ')
      "
    >
      <div class="my-2 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl">
      <div class="relative overflow-x-auto mt-4 mb-6">
        <div class="flex items-center justify-between pb-4 mx-5">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.employee.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
        </div>
        <EasyDataTable
          :headers="headers"
          :items="filterItems"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <button
              class="mx-1 my-1"
              @click="showModal(item)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '28',
                  action: 'edit',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '28',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
          </template>
          <template #loading>
            <div class="flex items-center justify-center py-8">
              <img
                src="../../assets/loading.webp"
                class="w-16 h-16 animate-pulse"
                alt="Loading..."
              />
            </div>
          </template>
          <template #item-status="item">
            <span
              class="bg-red-500 px-1 rounded text-white"
              v-if="item.status != 1"
            >
              {{ $t("inactive") }}
            </span>
            <span
              class="bg-green-500 px-1 rounded text-white"
              v-if="item.status == 1"
            >
              {{ $t("active") }}
            </span>
          </template>
          <template #item-box_access="item">
            <span v-if="!item.bo_id || item.bo_id.length === 0" 
                  class="bg-green-100 dark:bg-green-900 px-2 py-1 rounded text-green-800 dark:text-green-200 text-xs font-medium">
              {{ $t("all_boxes") }}
            </span>
            <div v-else class="flex flex-wrap gap-1">
              <span v-for="boxId in item.bo_id" :key="boxId"
                    class="bg-blue-100 dark:bg-blue-900 px-2 py-1 rounded text-blue-800 dark:text-blue-200 text-xs font-medium">
                {{ getBoxName(boxId) }}
              </span>
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          >
          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400">
              <i class="fa-solid fa-inbox text-4xl mb-4"></i>
              <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
            </div>
          </template>
          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-right'
                    : ' fa-chevron-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-left'
                    : ' fa-chevron-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.name"
          :label="$t('employee_name')"
          :placeholder="$t('employee_name')"
          :rules="rules"
          :isError="checkRulesIsError(current.name, 'edit', rules).isError"
          :errorMsg="checkRulesIsError(current.name, 'edit', rules).errorMsg"
        />
        <BaseInput
          v-model="current.email"
          :label="$t('email')"
          :placeholder="$t('email')"
          :rules="rulesEmail"
          :isError="
            checkRulesIsError(current.email, 'edit', rulesEmail).isError
          "
          :errorMsg="
            checkRulesIsError(current.email, 'edit', rulesEmail).errorMsg
          "
        /><BaseInput
          v-model="current.u_phone"
          :label="$t('phone_number')"
          :placeholder="$t('phone_number')"
          :rules="rules"
          :isError="checkRulesIsError(current.u_phone, 'edit', rules).isError"
          :errorMsg="checkRulesIsError(current.u_phone, 'edit', rules).errorMsg"
        /><BaseInput
          v-model="password"
          :label="$t('password')"
          :placeholder="$t('password')"
          :rules="[]"
          :isError="checkRulesIsError(password, 'edit', []).isError"
          :errorMsg="checkRulesIsError(password, 'edit', []).errorMsg"
        />
        <DropdownInput
          v-model="current.ro_id"
          :label="$t('choose_role')"
          :placeholder="$t('choose_role')"
          :rules="rules_dropdown"
          :items="convertToListIdValueRoles"
          :isError="
            checkRulesIsError(current.ro_id, 'edit', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.ro_id, 'edit', this.rules_dropdown)
              .errorMsg
          "
        />
        <DropdownInput
          v-model="current.status"
          :label="$t('choose_status')"
          :placeholder="$t('choose_status')"
          :rules="rules_dropdown"
          :items="statuses"
          :isError="
            checkRulesIsError(current.status, 'edit', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.status, 'edit', this.rules_dropdown)
              .errorMsg
          "
        />
        
        <!-- Box Access Selection -->
        <div class="mb-6">
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            {{ $t('box_access') }}
          </label>
          <CustomMultiSelect
            v-model="selectedBoxes"
            :options="boxOptions"
            :placeholder="$t('select_boxes')"
            :headerText="$t('select_boxes_for_employee')"
            :searchPlaceholder="$t('search_boxes')"
            :noResultsText="$t('no_boxes_found')"
            :searchable="true"
            :showSelectAll="true"
            :showClearAll="true"
            prefixIcon="fa fa-box"
            :helperText="$t('leave_empty_for_all_boxes')"
          />
        </div>
        
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    DropdownInput,
    CustomMultiSelect,
  },
  data() {
    return {
      firstName: "",
      searchQuery: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      rulesEmail: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
        //check if email is valid
        (value) => {
          if (value) {
            const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (pattern.test(value)) return true;
            else return this.$t("email_is_not_valid");
          }
        },
      ],
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      name: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      ro_id: "",
      selectedBoxes: [],
      statuses: [
        {
          id: 1,
          value: this.$t("active"),
        },
        {
          id: 2,
          value: this.$t("inactive"),
        },
      ],
      loading: false,
      isHide: false,
    };
  },
  mounted() {
    // First load when the component is mounted
    if (
      this.$store.getters["checkUserAccess"]({
        id: "28",
        action: "view",
      })
    ) {
      this.getData();
    }
  },
  created() {
    this.$store.dispatch("role/getRoles");
    this.$store.dispatch("employee/getBoxes");
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.employee.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.employee.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("employee/SET_DELETE_SUCCESS", false);
      }
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.employee.isShowResultDialog;
    },
    filterItems() {
      return this.$store.getters["employee/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.employee.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.employee.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.employee.isBtnEditLoading;
    },
    convertToListIdValueRoles() {
      var roles = this.$store.state.role.roles;
      var list = [];
      for (const item of roles) {
        list.push({
          id: item.ro_id,
          value: item.ro_name,
        });
      }

      return list;
    },
    boxOptions() {
      const boxes = this.$store.state.employee.boxes;
      return boxes.map(box => ({
        value: box.bo_id,
        text: box.bo_name
      }));
    },
    headers() {
      return [
        { text: "#", value: "id", sortable: true },
        { text: this.$t("employee_name"), value: "name", sortable: true },
        { text: this.$t("email"), value: "email", sortable: true },
        { text: this.$t("phone_number"), value: "u_phone", sortable: true },
        { text: this.$t("status"), value: "status", sortable: true },
        { text: this.$t("role_id"), value: "ro_id", sortable: true },
        { text: this.$t("role_name"), value: "role.ro_name", sortable: true },
        { text: this.$t("box_access"), value: "box_access", sortable: false },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
  },

  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      this.$store.dispatch("employee/getItems");
    },
    handleSearchInput(value) {
      this.$store.commit('employee/SET_SEARCH', value);
    },
    getBoxName(boxId) {
      const box = this.$store.state.employee.boxes.find(b => b.bo_id === boxId);
      return box ? box.bo_name : `Box #${boxId}`;
    },
    async addEmployee(e) {
      e.preventDefault();
      //check form validation
      if (this.$store.state.employee.isBtnLoading == true) return;
      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.name, "add", this.rules).isError ||
        this.checkRulesIsError(this.email, "add", this.rulesEmail).isError ||
        this.checkRulesIsError(this.u_phone, "add", this.rules).isError ||
        this.checkRulesIsError(this.password, "add", this.rules).isError ||
        this.checkRulesIsError(this.ro_id, "add", this.rules_dropdown).isError
      ) {
        return;
      }
      this.$store.state.employee.isBtnLoading = true;
      
      // Convert selectedBoxes to array of IDs, or null if empty (for all boxes access)
      const boxIds = this.selectedBoxes.length > 0 
        ? this.selectedBoxes.map(box => box.value) 
        : null;
      
      var res = await this.$store.dispatch("employee/addNewItem", {
        name: this.name,
        email: this.email,
        u_phone: this.u_phone,
        password: this.password,
        ro_id: this.ro_id,
        bo_id: boxIds,
      });
      if (res.status == 200) {
        this.name = "";
        this.email = "";
        this.u_phone = "";
        this.password = "";
        this.selectedBoxes = [];
        this.isSubmited = false;
        this.$store.state.employee.isBtnLoading = false;
      }
    },

    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("employee/REMOVE_ITEM", id);
        this.$store.dispatch("employee/deleteItem", id);
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      
      // Populate selectedBoxes based on employee's current box access
      if (item.bo_id && Array.isArray(item.bo_id) && item.bo_id.length > 0) {
        // Employee has specific boxes assigned
        this.selectedBoxes = this.boxOptions.filter(box => 
          item.bo_id.includes(box.value)
        );
      } else {
        // Employee has access to all boxes (bo_id is null or empty)
        this.selectedBoxes = [];
      }
      
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.name, "edit", this.rules).isError ||
        this.checkRulesIsError(this.current.email, "edit", this.rulesEmail)
          .isError ||
        this.checkRulesIsError(this.current.u_phone, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.ro_id, "edit", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.current.status, "edit", this.rules_dropdown)
          .isError
      ) {
        return;
      }
      this.$store.state.employee.isBtnEditLoading = true;
      
      // Convert selectedBoxes to array of IDs, or null if empty (for all boxes access)
      const boxIds = this.selectedBoxes.length > 0 
        ? this.selectedBoxes.map(box => box.value) 
        : null;
      
      var res = await this.$store.dispatch("employee/editItem", {
        id: this.current.id,
        name: this.current.name,
        email: this.current.email,
        u_phone: this.current.u_phone,
        password: this.password,
        ro_id: this.current.ro_id,
        status: this.current.status,
        bo_id: boxIds,
      });

      this.isSubmitedEdit = false;
      this.$store.state.employee.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
      }
    },
  },
};
</script>
